import { render, staticRenderFns } from "./OfferMealModal.vue?vue&type=template&id=71a6f080&"
import script from "./OfferMealModal.vue?vue&type=script&lang=js&"
export * from "./OfferMealModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports